import React, { useEffect } from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { signIn } from "../../utils/auth";
import { JSEncrypt } from "jsencrypt";
import { cryptoPassword } from "../../utils/crypto";
import { checkAuth } from "../../utils/auth";

export default function Login() {
  const navigate = useNavigate();
  useEffect(() => {
    const checkToken = async () => {
      const isLogin = await checkAuth();
      if (isLogin) {
        navigate("/");
      }
    };
    checkToken();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const mobile_phone = form.elements.mobile_phone.value;
    const password = form.elements.password.value;

    if (!mobile_phone.match(/^1[3456789]\d{9}$/)) {
      alert("手机号码格式错误");
      return;
    }
    if (password.length < 8) {
      alert("密码不得小于8位");
      return;
    }
    if (password.length > 15) {
      alert("密码不得大于15位");
      return;
    }
    //对手机号进行RSA加密
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(process.env.REACT_APP_RSA_KEY);
    const encrypted_mobile_phone = encrypt.encrypt(mobile_phone);
    //MD5加密password
    const encryptedPassword = cryptoPassword(password);
    //发送登录请求
    try {
      const response = await fetch(`/op/login/login_by_pswd`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobile_phone: encrypted_mobile_phone,
          region_code: "86",
          password: encryptedPassword,
        }),
      });
      const data = await response.json();
      if (data.ret === -1) {
        alert(data.msg);
        return;
      }
      signIn(data);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <p className="login-form-title">登录您的账号</p>
        <div className="login-input-container">
          <input type="text" name="mobile_phone" placeholder="输入账号" />
        </div>
        <div className="login-input-container">
          <input type="password" name="password" placeholder="输入密码" />
        </div>
        <button type="submit" className="login-submit">
          登录
        </button>
      </form>
    </div>
  );
}
